import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'
import WhatshotSharpIcon from '@mui/icons-material/WhatshotSharp'

export const GamificationSummaryCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(4, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0),
  },
  '& .inner': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 10,
    backgroundColor: colors.black,
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(2, 0),
    },
    '& .left': {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(1, 0, 1, 4),
      '& img': {
        height: 30,
        margin: theme.spacing(2, 1),
        [theme.breakpoints.down('md')]: {
          height: 20,
        },
      },
      '& .title': {
        fontSize: fontSizes.medium,
        fontWeight: 700,
        color: colors.gray.gray20,
        margin: theme.spacing(2, 1),
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.small,
          fontWeight: 600,
        },
      },
    },
    '& .right': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      margin: theme.spacing(1, 4, 1, 0),
      '& p': {
        fontSize: fontSizes.medium,
        fontWeight: 700,
        color: colors.gray.gray20,
        margin: theme.spacing(0, 1),
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.small,
          fontWeight: 600,
        },
      },
      '& .streakCon': {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          marginLeft: theme.spacing(1),
        },
      },
    },
  },
}))

export const StreakFire = styled(WhatshotSharpIcon)(
    () => ({
      color: colors.red,
      display: 'flex',
      alignItems: 'center',
      height: 30
    })
  )